'use client';

import { useState } from 'react';

import { Box, Container } from '@mui/material';

import { CustomerElearning } from 'src/sections/landing/components/customer-elearning';
import { CenterRegisterForm } from 'src/sections/landing/components/center-register-form';
import { TestimonialElearning } from 'src/sections/landing/components/testimonial-elearning';

import { IntroTeacherManage } from '../components/intro-teacher-manager';
import { DetailTeacherManageFunction } from '../components/detail-teacher-manage-function';
import { StartWithCenterUpTeacherManage } from '../components/start-with-center-up-teacher-manage';

export const TeacherManagementSubPageView = () => {
  const [openDemo, setOpenDemo] = useState<boolean>(false);
  return (
    <Box sx={{ overflowX: 'hidden', width: 1 }}>
      <Container>
        <IntroTeacherManage setOpenDemoForm={() => setOpenDemo(true)} />
        <CustomerElearning />
      </Container>
      <Container>
        <DetailTeacherManageFunction />
      </Container>{' '}
      <TestimonialElearning />
      <Container>
        <StartWithCenterUpTeacherManage setOpenDemoForm={() => setOpenDemo(true)} />
      </Container>
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
    </Box>
  );
};
